/* global */
// BEGIN VENDOR ASSETS
// Import theme specific vendor assets here, this should be a rare case
// END VENDOR ASSETS

// BEGIN INDIVIDUAL COMPONENT SCRIPTS
// NOTE: If your component does not need specific script functiionality there
// is no need to include the default scripts from the component starter

import '../../components/component-navigation/src/scripts/_base.js'
import '../../components/component-specials-2/src/scripts/_base.js'
import '../../components/component-accordion/src/scripts/_base.js'
import { initEmbarkSightMapFloorOnMapTab } from './sightmap-floor.js'

// END INDIVIDUAL COMPONENT SCRIPTS

(($) => {
  window.COMPONENTSCHILD || (window.COMPONENTSCHILD = {})

  COMPONENTSCHILD.init = () => {
    console.log('HELLO FROM COMPONENTS CHILD THEME')
  }

  COMPONENTSCHILD.reLayoutGallery = () => {
    // Check if page has .gallery class
    if ($('body').hasClass('gallery') || $('html').hasClass('gallery')) {
      const $galleryCards = $('[data-ecs-components-control="gallery"]')
      
      if ($galleryCards.length && $galleryCards.data('isotope')) {
        // Trigger isotope layout recalculation
        $galleryCards.isotope('layout')
        console.log('Gallery isotope re-layout triggered')
      }
    }
  }

  $(document).ready(() => {
    COMPONENTSCHILD.init()

    initEmbarkSightMapFloorOnMapTab()

    // Nice Select can't tell a placeholder from a value; flag it so the field can be styled
    $('.ecs_form--employer select[data-ecs-components-control="nice-select"]').on('change', function () {
      $(this).next('.nice-select').toggleClass('has-value', !!$(this).val())
    })
    if (window.location.search.includes('spaces_tab=map')) {
      window.setTimeout(() => {
        const spacesSightMap = document.getElementById('spaces_sightmap')
        if (!spacesSightMap) return false
        if (typeof SightMap === 'undefined' || typeof SightMap.Embed !== 'function') return false
  
        const sightMapEmbed = new SightMap.Embed('spaces_sightmap')
        sightMapEmbed.setFloor(154302)
        return true
      }, 1000)
    }

  })

  // Re-layout gallery after all images are loaded
  $(window).on('load', () => {
    COMPONENTSCHILD.reLayoutGallery()
  })

}
)(jQuery)
